import { WppActionButton, WppIconDownload } from '@wppopen/components-library-react'

interface DownloadAllButtonProps {
  onClick: () => void
  isLoaded?: boolean
  itemCount?: number
  disabled?: boolean
}

function DownloadAllButton({ onClick, isLoaded, itemCount, disabled }: DownloadAllButtonProps) {
  return (
    <>
      <WppActionButton data-testid="download-all-button" loading={isLoaded} onClick={onClick} disabled={disabled}>
        <WppIconDownload slot="icon-start" />
        Download
        {!itemCount ? ' all' : ` (${itemCount})`}
      </WppActionButton>
    </>
  )
}

export default DownloadAllButton
